import { Divider } from '@mui/material';
import { useExtraModalStore } from 'src/stores/ModalStore';
import styled from 'styled-components';
import { NextButton } from '../common/CommonStyled';
import InputBoxSearch from '../inputbox/InputBoxSearch';
import SearchIcon from "src/assets/images/Icon_Search.svg";
import { getTeamMember } from 'src/api/Admin';
import ExtraModalTable from './ExtraModalTable';
import { useState } from 'react';

const PageWrapper = styled.div`
    height: 772px;
`
const PageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    position: absolute;
    right: 0;
`
const DefaultDiv = styled.div`
    color: #000;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`

const ExtraModalAddTeamMember = () => {
    const setField = useExtraModalStore((state)=>state.setField);
    const [searchText,setSearchText] = useState('')
    const [data,setData] = useState([])
    const [searchTextProps,setSearchTextProps] = useState('')

    const handleClose = () => {
        setField('open',false);
    }
    const handleSearchText = (e: React.ChangeEvent<HTMLInputElement>)=>{
        setSearchText(e.target.value)
    }
    const handleSubmit = async () => {
        const response = await getTeamMember(searchText)
        setData(response.data)
        setSearchTextProps(searchText)
    }

    return (
        <PageWrapper>
            <PageContainer>
                팀 생성
                <ButtonWrapper>
                    <NextButton style={{width:'94px', height:'100%'}} onClick={handleClose} disabled={false}>닫기</NextButton>
                </ButtonWrapper>
            </PageContainer>
            <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
            <div style={{height:'60px', margin:'24px 0px'}}>
                <InputBoxSearch 
                    icon={<img src={SearchIcon} style={{ opacity: 0.5 }} alt="search icon" />}
                    placeholder='홍보관 검색(이름, 아이디, 연락처)'
                    inputStyle={{fontSize:'16px'}}
                    value={searchText}
                    onChange={handleSearchText}
                    onClick={handleSubmit}
                />
            </div>
            <DefaultDiv style={{margin:'24px 0px'}}>홍보관 검색 결과</DefaultDiv>
            <ExtraModalTable data={data} searchText={searchTextProps}/>
        </PageWrapper>
    );
};

export default ExtraModalAddTeamMember;